import * as React from 'react'
import { NavigationContainerRef } from '@react-navigation/core'
import { NativeStackParams } from '../stacks/native-stack/types'

const navigationRef = React.createRef<
  NavigationContainerRef<NativeStackParams>
>()
export default navigationRef
